import React, { useState } from 'react';
import * as _ from 'lodash';
// utilities
import { USER_ROLES } from '../../utilities/constants';

// pages
import { useGetDirectNoticeUnapprovedWorkSettingData } from '../../pages/ExternalServiceCooperation';

// components
import Auth from '../Auth';
import { CheckCircleIcon } from '../icons/CheckCircleIcon';
import DirectSuspendGuideModal from './DirectSuspendGuideModal';

//modals
import DirectNoticeSettingModal from './DirectNoticeSettingModal';
import DirectNoticeStopModal from './DirectNoticeStopModal';

export default function InUseContents() {
  const [isShowSuspendGuideModal, setIsShowSuspendGuideModal] = useState(false);
  return (
    <React.Fragment>
      <CheckCircleIcon className='icon--2_4x ExternalServiceCooperation__contents-status-icon--cooperated' />
      <div className='ExternalServiceCooperation__contents-status ExternalServiceCooperation__contents-status--cooperated'>
        連携中
      </div>
      <div className='ExternalServiceCooperation__contents-btn-group Direct-inuse'>
        <Auth
          approvedRoles={[
            USER_ROLES.prime,
            USER_ROLES.branch,
            USER_ROLES.manager,
          ]}
        >
          <div className='ExternalServiceCooperation__contents-btn'>
            <button
              className='btn--negative'
              onClick={() => {
                setIsShowSuspendGuideModal(true);
              }}
            >
              連携停止
            </button>
          </div>
          <div className='ExternalServiceCooperation__contents-btn-right'>
            <NoticeSetiing />
          </div>
        </Auth>
      </div>
      <DirectSuspendGuideModal
        visible={isShowSuspendGuideModal}
        setVisible={setIsShowSuspendGuideModal}
        isInUse={true}
      />
    </React.Fragment>
  );
}

function NoticeSetiing() {
  const noticeUnapprovedWorkSettingData = useGetDirectNoticeUnapprovedWorkSettingData();
  const [isShowNoticeSettingModal, setIsShowNoticeSettingModal] = useState(
    false
  );
  const [isShowNoticeStopModal, setIsShowNoticeStopgModal] = useState(false);
  return (
    <React.Fragment>
      <div className='ExternalServiceCooperation__contents-btn'>
        <button
          className='btn--stay'
          onClick={() => {
            setIsShowNoticeSettingModal(true);
          }}
        >
          メッセージ通知設定
        </button>
      </div>
      {noticeUnapprovedWorkSettingData.isConfigured() && (
        <div className='ExternalServiceCooperation__contents-btn'>
          <button
            className='btn--negative'
            onClick={() => {
              setIsShowNoticeStopgModal(true);
            }}
          >
            メッセージ通知停止
          </button>
        </div>
      )}
      <DirectNoticeSettingModal
        visible={isShowNoticeSettingModal}
        setVisible={setIsShowNoticeSettingModal}
      />
      <DirectNoticeStopModal
        visible={isShowNoticeStopModal}
        setVisible={setIsShowNoticeStopgModal}
      />
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/externalService/DirectInUseContents.jsx